import React, { useEffect, useState } from "react";
import { datadogRum } from "@datadog/browser-rum";
import Dropdown from "../DropDown";
import apiClient from "../../../services/apiClient";
import { getHeaders } from "../../ApiHeaders/apiHeaders";

interface AncillaryServiceNodeDropdownProps {
  selectedISO: string;
  selectedAncillaryId: number | "";
//   onNodeChange: (nodeId: number | "", nodeObj?: { id: number; name: string }) => void;
onNodeChange: (nodeId: number | "" | null, nodeObj?: { id: number; name: string }) => void;

  disabled?: boolean;
  className?: string;
  onFocus?: () => void;
}

const AncillaryServiceNodeDropdown: React.FC<AncillaryServiceNodeDropdownProps> = ({
  selectedISO,
  selectedAncillaryId,
  onNodeChange,
  disabled = false,
  className = "",
  onFocus,
}) => {
  const [allRegions, setAllRegions] = useState<Record<string, any[]>>({});
  const [filteredRegions, setFilteredRegions] = useState<{ id: number; name: string }[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAncillaryNodes = async () => {
      const startTime = performance.now();
      try {
        const headers = await getHeaders();
        const response = await apiClient.get(`/ref-data/region`, { headers });

        // console.log("Raw response:", response.data);

        const apiData =
          response?.data?.response?.data ??
          response?.data?.data ??
          response?.data ??
          {};

        if (apiData && typeof apiData === "object") {
          setAllRegions(apiData);
          datadogRum.addAction("Fetched Ancillary Service Nodes", {
            isoCount: Object.keys(apiData).length,
          });
          setError(null);
        } else {
          throw new Error("Invalid response format for Ancillary Service Nodes");
        }
      } catch (err: any) {
        console.error(" Error fetching Ancillary Service Nodes:", err);
        setError("Failed to load Ancillary Service Nodes");
        datadogRum.addError("Error fetching Ancillary Service Nodes", { error: err });
      } finally {
        setLoading(false);
        const endTime = performance.now();
        datadogRum.addAction("Ancillary Node Fetch Duration", {
          duration: endTime - startTime,
        });
      }
    };

    fetchAncillaryNodes();
  }, []);

  useEffect(() => {
    if (selectedISO && allRegions[selectedISO]) {
      const rawRegions = allRegions[selectedISO];
  
      const uniqueRegionsMap = new Map<string, { id: number; name: string }>();
      rawRegions.forEach((item) => {
        if (!uniqueRegionsMap.has(item.REGION)) {
          uniqueRegionsMap.set(item.REGION, {
            id: item.REGION_ID,
            name: item.REGION,
          });
        }
      });
  
      const uniqueRegions = Array.from(uniqueRegionsMap.values());
      setFilteredRegions(uniqueRegions);
    } else {
      setFilteredRegions([]);
    }
  }, [selectedISO, allRegions]);
  
  const options = [
    { value: "none", label: "— No Region —" },
    ...filteredRegions.map((region) => ({
      value: region.id.toString(),
      label: region.name,
    })),
  ];
  
  return (
    <Dropdown
      options={options}
    //   selectedValue={selectedAncillaryId ? selectedAncillaryId.toString() : ""}
    //   onValueChange={(value) => {
    //     const selectedId = value ? Number(value) : "";
    //     const nodeObj = filteredRegions.find((n) => n.id === selectedId);
    //     onNodeChange(selectedId, nodeObj);
    //   }}
    selectedValue={
        selectedAncillaryId === null ? "none" :
        selectedAncillaryId ? selectedAncillaryId.toString() : ""
      }
      
      onValueChange={(value) => {
        const selectedId = value === "none" ? null : value ? Number(value) : "";
        const nodeObj = filteredRegions.find((n) => n.id === selectedId);
        onNodeChange(selectedId, nodeObj);
      }}
      
      
      
      disabled={disabled || loading || !!error || !selectedISO}
      className={className}
      placeholder={
        loading
          ? "Loading..."
          : error
          ? error
          : !selectedISO
          ? "Select ISO first"
          : "Select Ancillary Service Node"
      }
      onFocus={onFocus}
    />
  );
};

export default AncillaryServiceNodeDropdown;
